import React, { useState, useEffect } from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import Master from './Master';
import Login from '../components/login/login';
import Register from '../components/login/register';
import Forgot from '../components/login/forgot';
import Otp from '../components/login/otp';
import { getAuthState } from '../assets/scripts/login-util';
import { redirectToLogout } from "../components/api/common";
import Reset from '../components/login/reset';
import VerifyEmail from '../components/login/verifyEmail';
import Invoice from '../components/paymentGateway/invoice';
import GameVerification from '../components/scorecard/gameVerification';
import LoginWithOTP from '../components/login/loginWithOTP';
import RateCard from '../components/pages/rateCard';
import BookingTerms from '../components/pages/bookingTerms';
import PageFail from '../components/paymentGateway/pageFail';
import PaymentResponse from '../components/login/paymentResponse';
import CashCard from '../components/paymentGateway/cashCard';

const App = () => { 
    const [auth,            setAuth]                    = useState(getAuthState('bool'));

    useEffect(() => {
        const authorized = getAuthState('bool');
        if (authorized === 'Expired') redirectToLogout()
        else {
           setAuth(authorized);
        }
    }, []);

    const authHandler = async () => {
        const authorized = getAuthState('bool');
        authorized === 'Expired' ? setAuth(false) : setAuth(authorized);
    }

    
    return (
        <BrowserRouter>
            <Switch>
                <Route path="/cash-card" exact>
                    <CashCard />
                </Route>
                <Route path="/rate-card">
                    <RateCard />
                </Route>
                <Route path="/invoice" exact>
                    <Invoice />
                </Route> 
                <Route path="/booking-terms">
                    <BookingTerms />
                </Route>
                {auth ? (
                <>
                    <Route path="/verify-email" exact>
                        <VerifyEmail />
                    </Route>
                    <Route path="/payment-status" exact>
                        <PaymentResponse />
                    </Route>
                    <Route path="/game-verification" exact>
                        <GameVerification />
                    </Route>
                    <Route path="/page-fail">
                        <PageFail />
                    </Route>
                    <Master auth={auth} />
                </>
            ) : (
                <>
                    <Route path="/login" exact>
                        <Login onLogin={authHandler} />
                    </Route>
                    <Route path="/login-with-otp" exact>
                        <LoginWithOTP onLogin={authHandler} />
                    </Route>
                    <Route path="/registration" exact>
                        <Register onLogin={authHandler} />
                    </Route>
                    <Route path="/forgot-password" exact>
                        <Forgot onLogin={authHandler} />
                    </Route>
                    <Route path="/verify-otp" exact>
                        <Otp onLogin={authHandler} />
                    </Route>
                    <Route path="/reset-password" exact>
                        <Reset onLogin={authHandler} />
                    </Route>
                    <Route path="/verify-email" exact>
                        <VerifyEmail />
                    </Route>
                    <Route path="/game-verification" exact>
                        <GameVerification />
                    </Route>
                    <Redirect to="/login" />
                    </>
            )}           
            </Switch>
        </BrowserRouter>
    );

};

export default App;